/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Device_Missing_Code_BodyInputs */



/**
* | output |
* | --- |
* | "Type the code shown in your desktop app to continue." |
*
* @param {Auth_Device_Missing_Code_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_device_missing_code_body = /** @type {((inputs?: Auth_Device_Missing_Code_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Device_Missing_Code_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gib den in deiner Desktop-App angezeigten Code ein, um fortzufahren.")
	return /** @type {LocalizedString} */ ("Type the code shown in your desktop app to continue.")
});